<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="page page-container">
            <div class="novo-unidademedidaarea">
                <!-- TÍTULO -->
                <h1 class="title">
                    {{ $t("unidade-medida-area") }}:
                    {{
                        !unidademedidaarea.idunidademedidaarea
                            ? $t("novo-unidade-medida-area")
                            : unidademedidaarea.descricao
                    }}
                </h1>

                <!-- BREADCRUMB -->
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ $t("agro") }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{
                                $t("agro-cadastros")
                            }}</a>
                        </li>
                        <li>
                            <a
                                @click="
                                    $router.push({
                                        name: 'agro-unidademedidaarea',
                                    })
                                "
                                >{{ $t("unidade-medida-areas") }}</a
                            >
                        </li>
                        <li>
                            <a aria-current="page">{{
                                !unidademedidaarea.idunidademedidaarea
                                    ? $t("novo-unidade-medida-area")
                                    : unidademedidaarea.descricao
                            }}</a>
                        </li>
                    </ul>
                </nav>

                <!-- FORMULÁRIO -->
                <div class="columns mt-1 pb-3">
                    <div class="column is-2">
                        <v-input
                            :id="'codigo'"
                            ref="idunidademedidaareaerp"
                            v-model="unidademedidaarea.idunidademedidaareaerp"
                            placeholder="placeholder-preencha"
                            :maxlength="30"
                            title="codigo"
                            uppercase
                        />
                    </div>
                    <div class="column is-4">
                        <v-input
                            v-model="unidademedidaarea.descricao"
                            ref="descricaoInput"
                            :id="'descricao'"
                            :placeholder="'descricao-da-unidade-medida-area-placeholder'"
                            :maxlength="255"
                            :title="'descricao'"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!unidademedidaarea.descricao"
                            :disabled="
                                (isSaving || saved) ||
                                (isUpdate && !permissao.update) ||
                                (!isUpdate && !permissao.create)
                            "
                            :required="true"
                        />
                    </div>

                    <div class="column">
                        <v-input
                            class="always-lower"
                            v-model="unidademedidaarea.sigla"
                            ref="siglaInput"
                            :id="'sigla'"
                            :placeholder="'sigla-da-unidade-medida-area-placeholder'"
                            :maxlength="10"
                            :title="'sigla'"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!unidademedidaarea.sigla"
                            :disabled="
                                (isSaving || saved) ||
                                (isUpdate && !permissao.update) ||
                                (!isUpdate && !permissao.create)
                            "
                            :required="true"
                        />
                    </div>

                    <div class="column">
                        <v-input
                            v-model="unidademedidaarea.valorEmMetrosQuadrados"
                            ref="valorEmMetrosQuadradosInput"
                            type="tel"
                            validchars="0123456789.,"
                            :id="'valorEmMetrosQuadrados'"
                            :placeholder="'valorEmMetrosQuadrados-do-unidade-medida-area-placeholder'"
                            :min="0"
                            :title="'valorEmMetrosQuadrados'"
                            :msg="
                                !unidademedidaarea.valorEmMetrosQuadrados
                                    ? 'msg-campo-obrigatorio'
                                    : parseFloat(
                                          unidademedidaarea.valorEmMetrosQuadrados
                                      ) <= 0
                                    ? 'msg-qtd-zero-invalid'
                                    : ''
                            "
                            :invalid="
                                !unidademedidaarea.valorEmMetrosQuadrados ||
                                parseFloat(
                                    unidademedidaarea.valorEmMetrosQuadrados
                                ) <= 0
                            "
                            :disabled="
                                (isSaving || saved) ||
                                (isUpdate && !permissao.update) ||
                                (!isUpdate && !permissao.create)
                            "
                            :required="true"
                        />
                    </div>

                    <div class="column is-narrow">
                        <button
                            class="save-btn small-btn table-btn"
                            @click="showModal = true"
                        >
                            {{ $t("tabela-conversoes") }}
                        </button>
                    </div>
                </div>

                <b-modal :active.sync="showModal">
                    <div class="modal-card modal-default">
                        <section class="modal-card-body">
                            <table class="table is-100">
                                <thead>
                                    <tr>
                                        <td>{{ $t("unidade-medida") }}</td>
                                        <td>
                                            {{
                                                $t(
                                                    "valorEmMetrosQuadrados"
                                                )
                                            }}
                                        </td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="u in unidades" :key="u.nome">
                                        <td>{{ $t(u.nome) }}</td>
                                        <td>{{ getDecimal(u.m2, 0) }}</td>
                                        <td class="is-flex is-flex-centered">
                                            <button
                                                class="save-btn small-btn"
                                                @click="useValue(u.m2)"
                                            >
                                                {{ $t("utilizar") }}
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                    </div>
                </b-modal>

                <!-- BOTÕES -->
                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="
                            $router.push({ name: 'agro-unidademedidaarea' })
                        "
                        :disable="saved"
                    >
                        {{ $t("voltar") }}
                    </button>
                    <button
                        v-if="
                            ((!isUpdate && permissao.create) ||
                            (isUpdate && permissao.update)) && !unidademedidaareaIntegracao
                        "
                        class="save-btn"
                        type="button"
                        @click="saveUnidadeMedidaArea()"
                        :disabled="isSaving || saved"
                    >
                        {{ $t("salvar") }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UnidadeMedidaAreaService from "@/services/UnidadeMedidaAreaService";
import UnidadeMedidaAreaValidation from "@/services/validations/UnidadeMedidaAreaValidation";
import Message from '@/models/Message';

export default {
    data() {
        return {
            unidademedidaareaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("UNIDADEMEDIDAAREA"),
            id: this.$route.params.id,
            service: new UnidadeMedidaAreaService(this.$http, this.$router),
            validation: new UnidadeMedidaAreaValidation(this.$root.msgs),
            isSaving: false,
            saved: false,
            unidademedidaarea: {},
            title: "",
            showModal: false,
            unidades: [
                { nome: "are", m2: 100 },
                { nome: "hectare", m2: 10000 },
                { nome: "alqueire-norte", m2: 27225 },
                { nome: "alqueire-mineiro", m2: 48400 },
                { nome: "alqueire-paulista", m2: 24200 },
                { nome: "alqueire-baiano", m2: 96800 },
                { nome: "km2", m2: 1000000 },
                { nome: "mi2", m2: 2589988 },
            ],
            msgs: [],
            isUpdate: false,
            isLoading: false,
        };
    },
    created() {
        if (this.$route.params.id) {
            this.isUpdate = true;
        }
        this.permissao = this.hasPermissionAccess(
            "agro",
            "agro-cadastros",
            "agro-unidademedidaarea"
        );
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "agro-unidademedidaarea" },
            });
        } else {
            if (this.id) {
                this.carregarDados(this.id);
            }
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        carregarDados(id) {
            this.$store.commit("addLoader");

            this.isLoading = true;
            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.unidademedidaarea = body.content;
                        this.title = this.unidademedidaarea.descricao;
                    } else {
                        this.$router.push({
                            name: "agro-unidademedidaarea-new",
                        });
                    }
                })
                .catch((e) => {
                    console.error("Erro ao carregar unidade de medida.", e);
                    this.$root.showMessage("error", "msg-erro-dados-geral");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.$store.commit("removeLoader");
                });
        },
        saveUnidadeMedidaArea(redirect = this.redirectToList) {
            this.unidademedidaarea = this.mapToSavePreserveCase(
                this.unidademedidaarea
            );

            if (this.validation.validate(this.unidademedidaarea, this.$refs)) {
                this.isSaving = true;

                this.isLoading = true;
                this.service
                    .save(this.unidademedidaarea)
                    .then((body) => {
                        let msg = "msg-unidademedidaarea-salva";

                        if (this.unidademedidaarea.id) {
                            msg = "msg-unidademedidaarea-edita";
                        }

                        this.unidademedidaarea = body.content;
                        this.$root.showMessage("success", msg);
                        this.saved = true;

                        redirect(0.2);
                    })
                    .catch((e) => {
                        if (e.body.message) {
                            this.$root.showMessage("error", e.body.message);
                        } else {
                            this.$root.showMessage(
                                "error",
                                "msg-problema-realizar-acao"
                            );
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message("alert", "msg-campos-obrigatorios", true));
            }
        },
        useValue(valor) {
            this.unidademedidaarea.valorEmMetrosQuadrados = valor;
            this.showModal = false;
        },
        redirectToList(time) {
            setTimeout((_) => {
                this.$router.push({ name: "agro-unidademedidaarea-list" });
            }, time * 1000 + 50);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}

.page {
    position: relative;
    margin-bottom: 40px;

    .novo-unidademedidaarea {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;

        > h1 {
            padding-top: 20px;
            margin-bottom: 40px;
        }
    }
}

.form-buttons {
    right: 0;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}

.table-btn {
    height: 36px;
    margin-top: 1.5rem;
    margin-left: 0;
}

table.table thead tr td {
    font-weight: bold;
}
</style>